import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminDashboard from "./AdminDashboardComponent";
import Monitoring from "./monitoring/ApiStatsMonitoring";
import AnalyticsPage from "./analytics/AnalyticsComponent";

const MainAdminDashboard = () => {
  const navigate = useNavigate();
  const { tab: urlTab } = useParams();
  const [activeTab, setActiveTab] = useState(urlTab || "dashboard");

  const tabNames = {
    dashboard: "Dashboard",
    monitoring: "Monitoring",
    analytics: "Analytics",
  };

  const tabComponents = {
    dashboard: <AdminDashboard />,
    monitoring: <Monitoring />,
    analytics: <AnalyticsPage />,
  };

  useEffect(() => {
    setActiveTab(urlTab || "dashboard");
  }, [urlTab]);

  const handleTabClick = (key) => {
    navigate(`/account/admin-dashboard/${key}`);
    setActiveTab(key);
  };

  return (
    <div className="post-jobs-container">
      <div className="post-jobs-tabs">
        <div className="tabs-group">
          <div className="tabs">
            {Object.entries(tabComponents).map(([key, component]) => (
              <div
                key={key}
                className={`tab ${activeTab === key ? "active" : ""}`}
                onClick={() => handleTabClick(key)}
              >
                {tabNames[key]}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="post-job-tab-content">{tabComponents[activeTab]}</div>
    </div>
  );
};

export default MainAdminDashboard;
